<template>
  <div>
    <div class="title_text">
      <div>
        <Icon type="ios-bookmark" size="18" color="#0466dd" />
        <span class="title_text2">保险数据</span>
      </div>
      <div class="query_box"></div>
    </div>

    <div class="data_div">
      <div class="card_main">
        <Spin fix v-if="loading"></Spin>

        <div class="count_card">
          <div>
            <CountUp :end="zaizhi_total_count" :duration="4" v-font="18" />
          </div>
          <div class="count_title">在职人数</div>
        </div>
        <div class="count_card">
          <div>
            <CountUp :end="total_be_insured_list.length" :duration="4" v-font="18" />
          </div>
          <div class="count_title">总在参(险种去重)</div>
        </div>
        <div class="count_card" :class="lizhi_weitui_count > 0 ? 'abnormal_card_warn' : ''"
          :title="'离职未退保 ' + lizhi_weitui_count + ' 人'"
          @click="click_abnormal_idcard('离职未退保', lizhi_weitui_idcard_list)">
          <div>
            <CountUp :end="lizhi_weitui_count" :duration="4" v-font="18" />
          </div>
          <div class="count_title">离职未退保</div>
        </div>
        <div class="count_card" :class="zaizhi_weican_count > 0 ? 'abnormal_card_warn' : ''"
          :title="'在职未参保 ' + zaizhi_weican_count + ' 人'"
          @click="click_abnormal_idcard('在职未参保', zaizhi_weican_idcard_list)">
          <div>
            <CountUp :end="zaizhi_weican_count" :duration="4" v-font="18" />
          </div>
          <div class="count_title">在职未参保</div>
        </div>
        <div class="count_card10" @click="click_count('五险', wuxian_be_insured_list)">
          <div>
            <CountUp :end="wuxian_be_insured_list.length" :duration="4" v-font="18" />
          </div>
          <div class="count_title3">五险</div>
        </div>
        <div class="count_card10" @click="click_count('单工伤', gongshang_be_insured_list)">
          <div>
            <CountUp :end="gongshang_be_insured_list.length" :duration="4" v-font="18" />
          </div>
          <div class="count_title3">单工伤</div>
        </div>
        <div class="count_card10" @click="click_count('公积金', gongjijin_be_insured_list)">
          <div>
            <CountUp :end="gongjijin_be_insured_list.length" :duration="4" v-font="18" />
          </div>
          <div class="count_title3">公积金</div>
        </div>
        <div class="count_card10" @click="click_count('商业险', business_be_insured_list)">
          <div>
            <CountUp :end="business_be_insured_list.length" :duration="4" v-font="18" />
          </div>
          <div class="count_title3">商业险</div>
        </div>

        <div class="count_card10" @click="export_baofei_show = true">
          <span class="iconfont iconbaozhengjin"></span>
          <div class="count_title3">在职保费计算</div>
        </div>
        <div class="count_card10" @click="export_cancan">
          <Icon :type="export_cancan_loading ? 'ios-loading' : 'md-cloud-download'" class="export_icon"
            :class="{ export_icon_rotate: export_cancan_loading }" />
          <div class="count_title3">导出在参数据</div>
        </div>
      </div>
    </div>

    <Drawer :title="drawer_title" :closable="false" v-model="show" width="80">
      <div class="drawer_body">
        <Spin fix v-if="idcard_loading"></Spin>
        <Table size="small" ref="table" :height="windowHeight - 110" :columns="columns" :data="table_data">
          <template #business_list_str="{ row }">
            <span>{{ row.business_list_str }}</span>
            <!-- <div v-for="(item, i) in row.business_list" :key="i" class="bsiness_tag">
              {{ item.business_name }}/{{ item.business_product_name }}
            </div> -->
          </template>
          <template #name="{ row }">
            <span class="drawer_name" @click="click_drawer_name(row)">{{ row.name }}</span>
          </template>
        </Table>
      </div>
      <div class="export_div" @click="export_table">
        <Icon type="md-download" />导出表格
      </div>
    </Drawer>

    <Modal v-model="export_baofei_show" title="在职人员-保费计算" width="400" :footer-hide="true">
      <dir>日期使用方式：例如选1月，就选1月到2月</dir>
      <div class="baofei_div">
        <div>
          <DatePicker type="month" v-model="export_baofei_start_date" placeholder="开始月份" style="width: 120px" />
          <span style="padding: 5px">-</span>
          <DatePicker type="month" v-model="export_baofei_end_date" placeholder="结果月份" style="width: 120px" />
          <Button style="font-size: 13px; margin-left: 10px" type="primary" @click="click_zaizhi_baofei">开始计算</Button>
        </div>

        <Spin fix v-if="export_baofei_loading">
          <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
          <div>正在生成中，请稍等...</div>
        </Spin>
        <div class="export_down" v-if="export_baofei_object_name != ''">
          <Button @click="click_export_baofei">点击下载表格</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { http, open_new_page, get_view_file_url } from "@/utils/http.js";

export default {
  name: "insurance_data",
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      project_id: "",
      project_name: "",
      query_date: [],

      // 总在参
      total_be_insured_list: [],
      zaizhi_total_count: '',
      // 总在职
      zaizhi_list: [],
      // 在职未参保人数（后台返回）
      zaizhi_weican_count: 0,
      // 在职未参保身份证号列表（后台返回）
      zaizhi_weican_idcard_list: [],
      // 离职未退保人数（后台返回）
      lizhi_weitui_count: 0,
      // 离职未退保身份证号列表（后台返回）
      lizhi_weitui_idcard_list: [],
      // 商业险
      business_be_insured_list: [],
      // 公积金
      gongjijin_be_insured_list: [],
      // 单工伤
      gongshang_be_insured_list: [],
      // 五险
      wuxian_be_insured_list: [],

      show: false,
      columns: [],
      table_data: [],
      drawer_title: "",
      idcard_loading: false,

      loading: false,
      export_baofei_show: false,
      export_baofei_object_name: "",
      export_baofei_loading: false,

      export_baofei_start_date: null,
      export_baofei_end_date: null,
      is_export: 0,
      // 导出在参数据中
      export_cancan_loading: false,
      export_cancan_msg_close: null
    };
  },

  computed: {},

  methods() { this.window_change() },
  methods: {
    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },

    export_cancan() {
      if (this.export_cancan_loading) {
        return;
      }
      this.export_cancan_loading = true;
      this.is_export = 1;
      this.export_cancan_msg_close = this.$Message.loading({
        content: "正在导出中，请稍等",
        duration: 20,
      });
      this.get_insurance_data();
    },

    // 结束导出在参数据的 loading 与提示
    finish_export_cancan() {
      if (typeof this.export_cancan_msg_close === "function") {
        this.export_cancan_msg_close();
        this.export_cancan_msg_close = null;
      }
      this.export_cancan_loading = false;
      this.is_export = 0;
    },
    click_export_baofei() {
      get_view_file_url(this.export_baofei_object_name);
    },

    click_zaizhi_baofei() {
      if (this.export_baofei_start_date == null) {
        this.$Message.error("请选择开始月份");
        return;
      }
      if (this.export_baofei_end_date == null) {
        this.$Message.error("请选择结束月份");
        return;
      }

      if (this.export_baofei_start_date.getTime() >= this.export_baofei_end_date.getTime()) {
        this.$Message.error('结束月份需大于开始月份')
        return
      }

      var that = this;
      var obj = {
        zaizhi_list: this.zaizhi_list,
        project_id: this.project_id,
        start_time: this.export_baofei_start_date.getTime() / 1000,
        end_time: this.export_baofei_end_date.getTime() / 1000,
      };
      this.export_baofei_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST +
        "/my_project/project_detail/insurance_data/zaizhi_baofei",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.export_baofei_object_name = res.data.object_name;
            // this.$Modal.confirm({
            //   title: "提示",
            //   content: "<p>生成表格完成，是否下载？</p></p>",
            //   onOk: () => {
            //     get_view_file_url(object_name);
            //   },
            //   onCancel: () => {},
            // });
            that.export_baofei_loading = false;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
            that.export_baofei_loading = false;
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
          that.export_baofei_loading = false;
        });
    },

    click_count(title, data_list) {
      console.log(data_list);
      this.drawer_title = title + "-详情";
      this.show = true;
      this.columns = [
        {
          title: "序号",
          key: "index",
          width: 60,
        },
        {
          title: "姓名",
          key: "name",
          width: 130,
        },
        {
          title: "身份证号",
          key: "idcard",
          width: 180,
        },
        {
          title: "项目",
          key: "project_name",
          width: 180,
          sortable: true
        },

        {
          title: "在离职状态",
          key: "current_employment_status",
          width: 120,
          sortable: true,
        },
      ];
      if (title == '商业险') {
        this.columns.push({
          title: "商业险列表",
          key: "business_list_str",
          slot: 'business_list_str',
          minWidth: 180,
        },)
      }
      this.table_data = data_list;
    },

    // 点击参保异常卡片 -> 根据身份证号查询姓名/身份证号
    click_abnormal_idcard(title, idcard_list) {
      if (!idcard_list || idcard_list.length == 0) {
        this.$Message.info("暂无数据");
        return;
      }
      this.drawer_title = title + "-详情";
      this.columns = [
        {
          title: "序号",
          key: "index",
          width: 60,
        },
        {
          title: "姓名",
          key: "name",
          slot: 'name',
          width: 130,
        },
        {
          title: "手机号",
          key: "phone",
          width: 130,
        },
        {
          title: "身份证号",
          key: "idcard",
          width: 180,
        },
      ];
      this.table_data = [];
      this.show = true;
      this.get_idcard_resume_basic(idcard_list);
    },

    // 身份证号获取简历基本信息
    get_idcard_resume_basic(idcard_list) {
      var that = this;
      var obj = {
        idcard_list: idcard_list,
        project_id: this.project_id
      };
      that.idcard_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST +
        "/my_project/project_detail/insurance_data/get_idcard_resume_basic",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            var staff_list = res.data.staff_list || [];
            that.table_data = staff_list.map(function (item, index) {
              item.index = index + 1;
              return item;
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.idcard_loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
          that.idcard_loading = false;
        });
    },

    date_picker_change(e) {
      console.log(e);
      this.get_interview_data();
    },

    open(project_id, project_name) {
      this.project_id = project_id;
      this.project_name = project_name;

      this.get_insurance_data();
    },

    //保险数据
    get_insurance_data() {
      var that = this;
      var is_export = this.is_export;
      var obj = {
        project_id: this.project_id,
        is_export: is_export
      };
      // 导出时由导出按钮自身展示 loading，不再遮挡整块卡片
      that.loading = is_export == 0;
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_detail/insurance_data/cbzz_info",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.total_be_insured_list = res.data.cbzz_info.total_be_insured_list;
            that.zaizhi_list = res.data.zaizhi;
            that.zaizhi_weican_count = res.data.zaizhi_weican_count || 0;
            that.zaizhi_weican_idcard_list = res.data.zaizhi_weican_idcard_list || [];
            that.lizhi_weitui_count = res.data.lizhi_weitui_count || 0;
            that.lizhi_weitui_idcard_list = res.data.lizhi_weitui_idcard_list || [];
            that.wuxian_be_insured_list = res.data.cbzz_info.wuxian_be_insured_list;
            that.gongshang_be_insured_list = res.data.cbzz_info.gongshang_be_insured_list;
            that.gongjijin_be_insured_list = res.data.cbzz_info.gongjijin_be_insured_list;
            that.business_be_insured_list = res.data.cbzz_info.business_be_insured_list;
            that.zaizhi_total_count = res.data.zaizhi_total_count

            if (res.data.is_export == 1) {
              that.$Modal.confirm({
                title: '提示',
                content: '<p>导出完成，是否下载？</p>',
                onOk: () => {
                  get_view_file_url(res.data.export_object_name)
                },
                onCancel: () => {

                }
              });
            }
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading = false;
          that.finish_export_cancan();
        })
        .catch((res) => {
          console.log(res, "请求出错");
          that.loading = false;
          that.finish_export_cancan();
        });
    },

    export_table() {
      this.$refs.table.exportCsv({
        filename: "导出数据",
      });
    },

    click_drawer_name(row) {
      var url = 'https://insurance.daxiangsys.com/info/search/detail/?idcard=' + row.idcard + '&project_id=' + this.project_id
      open_new_page(url)
    }
  },
};
</script>

<style scoped>
.drawer_name {
  cursor: pointer;
  color: #0466dd
}

.drawer_body {
  position: relative;
}

.bsiness_tag {
  padding: 3px;
  background-color: #cff7dc;
  color: #494949;
  margin-right: 3px;
}

.baofei_div {
  padding-bottom: 50px;
}

.export_down {
  border: 1px solid #ccc;
  padding: 10px;
  margin-top: 10px;
  text-align: center;
}

.demo-spin-col .circular {
  width: 25px;
  height: 25px;
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}

.iconbaozhengjin {
  font-size: 19px;
  color: #ed2d07;
}

.export_icon {
  font-size: 22px;
  margin-top: 5px;
  color: #1a66ff;
}

.export_icon:hover {
  color: #fff
}

.export_icon_rotate {
  animation: ani-demo-spin 1s linear infinite;
}


.export_div {
  padding-top: 5px;
  align-items: center;
  display: flex;
  font-size: 13px;
  justify-content: flex-end;
  cursor: pointer;
  color: #0466dd;
}

.ratiospan {
  font-size: 18px;
  position: absolute;
  right: 20px;
  top: 8px;
}

.title_text2 {
  font-weight: 600;
}

.export_table {
  font-size: 12px;
  color: #0466dd;
  font-weight: 300;
  margin-right: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  letter-spacing: 1px;
}

.title_text {
  margin: 0px 10px 0 10px;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #ddd;
  padding: 10px 10px 5px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  letter-spacing: 2px;
}

.card_main {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  position: relative;
}

.count_title {
  font-size: 13px;
  color: #333;
  margin-top: 5px;
}

.count_title2 {
  font-size: 13px;
  color: #fff;
  margin-top: 5px;
}

.count_title3 {
  font-size: 13px;
  margin-top: 5px;
}

.count_card {
  position: relative;
  margin: 0 10px 10px 0;
  cursor: pointer;
  padding: 5px 10px 10px 10px;
  width: 130px;
  border: 1px solid #ececec;
  border-radius: 5px;
  background-color: #fff;
  text-align: center;
}

.abnormal_card_warn {
  border: 1px solid #f8491f;
  background-color: #fff5f2;
}

.count_card10 {
  position: relative;
  margin: 0 10px 10px 0;
  cursor: pointer;
  padding: 5px 10px 10px 10px;
  width: 130px;
  border: 1px solid #b8bef7;
  border-radius: 5px;
  background-color: #fff;
  text-align: center;
}

.count_card10:hover {
  background: #0466dd;
  color: #fff;

}

.count_card10:hover .export_icon {
  background: #0466dd;
  color: #fff;

}

.count_card10:hover .iconbaozhengjin {

  color: #fff;

}

.count_card2 {
  position: relative;
  margin: 0 10px 10px 0;
  cursor: pointer;
  padding: 5px 10px 10px 10px;
  width: 130px;
  border-radius: 5px;
  border: 1px solid #ececec;

  color: #fff;
  background-color: rgb(89, 146, 220);
  text-align: center;
}

.count_card3 {
  position: relative;
  margin: 0 10px 10px 0;
  cursor: pointer;
  padding: 5px 10px 10px 10px;
  width: 130px;
  border-radius: 5px;
  color: #fff;
  background-color: rgb(248, 73, 47);
  text-align: center;
}

.data_div {
  padding: 10px;
  border-radius: 5px;
}

.query_box {
  display: flex;
  justify-content: flex-end;
}
</style>
